import { Role } from "@linkfluence/models/role";
import { Project } from "@radarly/models/project";
import { User } from "@radarly/models/user";

export interface RolesRepo {
  attachUserRole(
    project: Project["id"],
    user: User["id"],
    role: Role
  ): Promise<{ ok: boolean }>;
  detachUserRole(
    project: Project["id"],
    user: User["id"]
  ): Promise<{ ok: boolean }>;
  setUserWorkspaces(
    project: Project["id"],
    user: User["id"],
    workspaceIds: number[]
  ): Promise<{ ok: boolean }>;
}

export const RolesRepoUID = Symbol("Radarly/RolesRepo");
